import type {CalypsoCatalog} from "#pricing/catalogs/calypso/catalog"
import type {KeyedVariants} from "#pricing/catalogs/graph-helpers"
import {createAmountTriggeredPriceNode, createKeyedVariantPriceNodes, createPriceContainer} from "#pricing/catalogs/graph-helpers"
import {MeshAmountNode} from "#pricing/nodes/mesh-amount-node"
import type {MeshesNode} from "#pricing/nodes/meshes-node"
import type {PriceContainer} from "#pricing/nodes/price-container"

/**
 * The Petra handles are triggered by their meshes: one handle mesh per unit (vanity, tall wall unit) with the same names on both, so the
 * mesh count is the number of handles. Floresta and Lucina take the finish from the accessory finish funnel (SKU suffix keys, since the
 * Lucina black row is "Black" and not "Matt Black"); Renaico comes in natural brass only, so mesh presence alone prices it.
 */
export function createPetraHandlesContainer(catalog: CalypsoCatalog, Meshes: MeshesNode, handleFinish: KeyedVariants): PriceContainer {
    const createFinishedHandleNodes = (sku: string, finishCount: number, meshName: string) =>
        createKeyedVariantPriceNodes(catalog, sku, finishCount, handleFinish, {amount: new MeshAmountNode({parameters: {name: meshName, meshes: Meshes}})})
    const createRenaicoNode = (sku: string, meshName: string) =>
        createAmountTriggeredPriceNode(catalog, sku, new MeshAmountNode({parameters: {name: meshName, meshes: Meshes}}))

    const florestaUnits = [
        ...createFinishedHandleNodes("3659", 2, "3659 - Floresta Bar Handle 167 x 35 x 12mm cc 128mm"),
        ...createFinishedHandleNodes("3663", 2, "3663 - Floresta Bar Handle 359 x 35 x 12mm cc 320mm"),
    ]

    const lucinaUnits = [
        ...createFinishedHandleNodes("3472", 3, "3472 - Lucina 16 Handle 32 x 14mm"),
        ...createFinishedHandleNodes("3475", 3, "3475 - Lucina 160 Handle 173 x 14mm"),
        ...createFinishedHandleNodes("3478", 3, "3478 - Lucina 320 Handle 334 x 14mm"),
    ]

    const renaicoUnits = [
        createRenaicoNode("3691NBR", "3691 - Renaico Bar Handle 136 x 16 x 32mm"),
        createRenaicoNode("3692NBR", "3692 - Renaico Bar Handle 264 x 16 x 32mm c-c 224mm Natural Brass"),
        createRenaicoNode("3693NBR", "3693 - Renaico Knob Handle 40 x 16 x 32mm Natural Brass"),
    ]

    return createPriceContainer("Petra Handles", "Petra Handles", [...florestaUnits, ...lucinaUnits, ...renaicoUnits], true)
}
